import React from "react";

function TreeItem(props) {
	// Determina las clases según isSmall
	const rowClass = props.isSmall
		? "small-tree__col__row flexer flexer-vcenter"
		: "tree__row flexer flexer-vcenter";

	const inputClass = props.isSmall ? "small-tree__input" : "tree__input";

	return (
		<div className={rowClass}>
			<input
				className={inputClass}
				placeholder="-"
				value={props.value || ""}
				readOnly
			/>
		</div>
	);
}

export default TreeItem;
